import { app } from '../../app.module'
// 反応数
app.component('engagements', {
  bindings: {
    engagementData: '=',
    snsType: '=',
  },
  template: require('./engagements.pug')(),
})
